import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Box from '@repo/ui/box'
import Loader from '@repo/ui/loader'
import { LogSection } from '@repo/ui/log-section'
import Typography from '@repo/ui/typography'
import { useQuery } from '@tanstack/react-query'

import { getCenterOlComments } from '../../../../../../../api/centers/center-ol-comments/get-center-ol-comments'

type Props = {
  id: number
}

const CenterOLComments = ({ id }: Props) => {
  const { data: centerOLComments, isPending } = useQuery({
    queryKey: ['center-ol-comments'],
    queryFn: () => getCenterOlComments({ centerId: id })
  })

  if (isPending) return <Loader center />

  if (centerOLComments?.total === 0) return null

  return (
    <Box className="bg-white-hover rounded-lg border border-grey-light ">
      <Typography variant="text" color={tailwindColors.primary.DEFAULT}>
        Commentaires du Prestataire
      </Typography>
      <div className="h-4" />
      <LogSection
        logItemClassName="bg-white border border-grey-light"
        data={
          centerOLComments?.data?.map((comment) => ({
            comment: comment.comment,
            updatedAt: new Date(comment.updatedAt)
          })) || []
        }
        dateFormatter={(date) => DateFormatter.ddMMyyyyHHmm(date)}
      />
    </Box>
  )
}

export default CenterOLComments
